import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';

class RecycleBinTable extends Component {
    getStatusClasses = (status) => {
        if (status === 'Borrado') {
            return 'label label-inline font-weight-bold text-white';
        }

        if (status === 'Restaurado') {
            return 'label label-inline font-weight-bold text-white';
        }

        if (status === 'Eliminado permanente' || status === 'Eliminado permanentemente') {
            return 'label label-inline font-weight-bold text-white';
        }

        return 'label label-inline font-weight-bold label-light-dark';
    }

    getStatusStyle = (status) => {
        if (status === 'Borrado') {
            return { backgroundColor: '#FF3D60' };
        }

        if (status === 'Restaurado') {
            return { backgroundColor: '#08D1AD' };
        }

        if (status === 'Eliminado permanente' || status === 'Eliminado permanentemente') {
            return { backgroundColor: '#25185C' };
        }

        return {};
    }

    static defaultProps = {
        modalId: null,
        person_provider_id: null,
        title: 'Tipos de Documentos RX',
        selectable: false,
        selectedIds: [],
        onSelectionChange: null,
        footerActions: null,
        logView: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            currentPage: 1,
            lastPage: 1,
            total: 0,
            perPage: 10,
            search: '',
            appliedSearch: '',
            recycleStatus: '',
            createdAtDate: '',
            createdAtStart: null,
            createdAtEnd: null,
            showDatePicker: false,
            loading: true,
            error: null,
        };

        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.searchTimeout = null;
        this.datePickerRef = React.createRef();
    }

    componentDidMount() {
        if (!this.props.modalId) {
            this.fetchRows();
        }

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {
        if (this.props.person_provider_id !== prevProps.person_provider_id) {
            this.setState({ currentPage: 1 }, this.fetchRows);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.state.showDatePicker && this.datePickerRef && this.datePickerRef.current && !this.datePickerRef.current.contains(event.target)) {
            this.setState({ showDatePicker: false });
        }
    }

    toggleSelection = (id) => {
        if (!this.props.onSelectionChange) {
            return;
        }

        const selectedIds = this.props.selectedIds || [];
        const nextSelectedIds = selectedIds.includes(id)
            ? selectedIds.filter((selectedId) => selectedId !== id)
            : [...selectedIds, id];

        this.props.onSelectionChange(nextSelectedIds);
    }

    openModal = () => {
        this.setState({ currentPage: 1 }, async () => {
            await this.fetchRows();
            if (this.props.modalId) {
                $(`#${this.props.modalId}`).modal('show');
            }
        });
    }

    closeModal = () => {
        if (this.props.modalId) {
            $(`#${this.props.modalId}`).modal('hide');
        }
    }

    updateCurrentPage(page) {
        this.setState({ currentPage: page }, this.fetchRows);
    }

    handleSearchChange = (event) => {
        const value = event.target.value;
        this.setState({ search: value });

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            this.setState({ appliedSearch: value, currentPage: 1 }, this.fetchRows);
        }, 400);
    }

    handleStatusFilterChange = (event) => {
        this.setState({
            recycleStatus: event.target.value,
            currentPage: 1,
            rows: [],
            total: 0,
            lastPage: 1,
            loading: true,
        }, this.fetchRows);
    }

    toggleDatePicker = () => {
        this.setState((prevState) => ({ showDatePicker: !prevState.showDatePicker }));
    }

    handleDateChange = (ranges) => {
        const { startDate, endDate } = ranges.selection || {};
        const createdAtStart = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const createdAtEnd = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

        this.setState({
            createdAtStart,
            createdAtEnd,
            createdAtDate: createdAtStart,
            currentPage: 1,
            rows: [],
            total: 0,
            lastPage: 1,
            loading: true,
        }, this.fetchRows);
    }

    clearDates = (event) => {
        if (event) {
            event.stopPropagation();
        }

        this.setState({
            createdAtDate: '',
            createdAtStart: null,
            createdAtEnd: null,
            currentPage: 1,
            rows: [],
            total: 0,
            lastPage: 1,
            loading: true,
        }, this.fetchRows);
    }

    clearFilters = () => {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.setState({
            search: '',
            appliedSearch: '',
            recycleStatus: '',
            createdAtDate: '',
            createdAtStart: null,
            createdAtEnd: null,
            showDatePicker: false,
            currentPage: 1,
            rows: [],
            total: 0,
            lastPage: 1,
        }, this.fetchRows);
    }

    fetchRows = async () => {
        this.setState({
            loading: true,
            error: null,
            rows: [],
            total: 0,
            lastPage: 1,
        });

        try {
            const params = new URLSearchParams({
                page: this.state.currentPage,
                per_page: this.state.perPage,
            });

            if (this.state.appliedSearch) {
                params.append('search', this.state.appliedSearch);
            }

            if (this.props.logView) {
                params.append('log_view', '1');
            }

            if (this.state.recycleStatus) {
                params.append('recycle_status', this.state.recycleStatus);
            }

            if (this.state.createdAtStart && this.state.createdAtEnd) {
                params.append('created_at_start', this.state.createdAtStart);
                params.append('created_at_end', this.state.createdAtEnd);
            }

            const personProviderId = this.props.person_provider_id || this.props.personProviderId;
            if (personProviderId) {
                params.append('person_provider_id', personProviderId);
            }

            const activeElement = document.activeElement;
            const selectionStart = activeElement && activeElement.tagName === 'INPUT' ? activeElement.selectionStart : null;
            const selectionEnd = activeElement && activeElement.tagName === 'INPUT' ? activeElement.selectionEnd : null;

            console.log('recycleDocuments request', {
                url: `/api/recycle/person-documents?${params.toString()}`,
                logView: this.props.logView,
                recycleStatus: this.state.recycleStatus,
                createdAtDate: this.state.createdAtDate,
                createdAtStart: this.state.createdAtStart,
                createdAtEnd: this.state.createdAtEnd,
                search: this.state.appliedSearch,
                personProviderId,
            });

            const response = await axios.get(`/api/recycle/person-documents?${params.toString()}`);
            const payload = response.data;
            console.log('recycleDocuments response', payload);

            this.setState({
                rows: payload.data || [],
                currentPage: payload.current_page || 1,
                lastPage: payload.last_page || 1,
                total: payload.total || 0,
                perPage: payload.per_page || this.state.perPage,
                error: null,
            }, () => {
                if (activeElement && typeof activeElement.focus === 'function' && document.body.contains(activeElement)) {
                    activeElement.focus();
                    if (selectionStart !== null && selectionEnd !== null && typeof activeElement.setSelectionRange === 'function') {
                        activeElement.setSelectionRange(selectionStart, selectionEnd);
                    }
                }
            });
        } catch (error) {
            this.setState({ error: 'No se pudo cargar la papelera.' });
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { rows, currentPage, total, perPage, loading, error, search, recycleStatus, createdAtDate, createdAtStart, createdAtEnd, showDatePicker, appliedSearch } = this.state;
        const selectedIds = Array.isArray(this.props.selectedIds)
            ? this.props.selectedIds.filter((id) => id !== null && id !== undefined)
            : [];
        const title = this.props.title || 'Papelera de reciclaje';
        const isLogView = this.props.logView;
        const outerTitle = isLogView ? 'Bitácora de documentos borrados' : 'Papelera de Reciclaje';
        const outerSubtitle = isLogView
            ? 'Consulte el historial de acciones realizadas sobre documentos eliminados, incluyendo borrado, restauración y eliminación permanente.'
            : 'Los siguientes documentos se encuentran en la papelera de reciclaje y podrán restaurarse dentro de un plazo máximo de 30 días antes de su eliminación permanente.';
        const innerTitle = isLogView ? 'Tipo de Documentos' : 'Tipos de Documentos';
        const innerSubtitle = isLogView ?  `${total} documentos disponibles.`: `${total} documentos eliminados.`;
        const filters = (
            <div className="card-header border-0 pt-6 d-block">
                <div className="d-flex justify-content-between mb-4 align-items-start flex-wrap">
                    <h3 className="card-title align-items-start flex-column mb-0">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{innerTitle}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{innerSubtitle}</span>
                    </h3>
                    
                </div>
                {isLogView ? (
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="font-weight-bolder">Filtrar por</div>
                            <a href="#" className="text-primary font-weight-bolder datatable-clear-filters" onClick={(event) => { event.preventDefault(); this.clearFilters(); }}>
                                <u>Limpiar todos los filtros</u>
                            </a>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">Acción</label>
                                <select
                                    className="form-control"
                                    value={recycleStatus}
                                    onChange={this.handleStatusFilterChange}
                                >
                                    <option value="">Todas</option>
                                    <option value="Borrado">Borrado</option>
                                    <option value="Restaurado">Restaurado</option>
                                    <option value="Eliminado permanente">Eliminado permanente</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">Fecha</label>
                                <div className="datepicker-container">
                                    <div className="position-relative">
                                        <div
                                            className="form-control d-flex align-items-center justify-content-between"
                                            onClick={this.toggleDatePicker}
                                        >
                                            <span>{createdAtStart ? moment(createdAtStart).format('ll') : 'Fecha inicio'}</span>
                                            <span className="mx-2">–</span>
                                            <span>{createdAtEnd ? moment(createdAtEnd).format('ll') : 'Fecha fin'}</span>
                                            {(createdAtStart || createdAtEnd) && (
                                                <span onClick={this.clearDates} className="ml-auto">
                                                    <i className="flaticon2-delete text-muted"></i>
                                                </span>
                                            )}
                                        </div>

                                        {showDatePicker && (
                                            <div ref={this.datePickerRef} className="date-range-popover">
                                                <DateRange
                                                    ranges={[{
                                                        startDate: createdAtStart ? new Date(createdAtStart) : new Date(),
                                                        endDate: createdAtEnd ? new Date(createdAtEnd) : new Date(),
                                                        key: 'selection'
                                                    }]}
                                                    onChange={this.handleDateChange}
                                                    editableDateInputs={true}
                                                    moveRangeOnFirstSelection={false}
                                                    months={1}
                                                    direction="horizontal"
                                                />
                                            </div>
                                        )}
                                       
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">Nombre del archivo</label>
                                <div className="input-icon">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar mis documentos"
                                        value={search}
                                        onChange={this.handleSearchChange}
                                    />
                                    <span>
                                        <i className="flaticon2-search-1 text-primary icon-md"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="row justify-content-end align-items-start">
                        <div className="col-md-4 ml-auto">
                            <div className="input-icon">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar mis documentos"
                                    value={search}
                                    onChange={this.handleSearchChange}
                                />
                                <span>
                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );

        const tableContent = (
            <>
                {loading && rows.length === 0 && <div>Cargando...</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                {!error && (
                    <>
                        {!isLogView && (
                            <>
                                <div className="row text-dark-75 font-weight-bolder mb-1 font-size-lg pb-3 mx-0">
                                    <div className={this.props.selectable ? 'col-md-5 col-5 px-0' : 'col-md-6 col-6 px-0'}>Nombre</div>
                                    <div className="col-md-4 col-4 px-0">Categoría</div>
                                    <div className="col-md-3 col-3 px-0">Expira en</div>
                                </div>
                                <div className="pt-3">
                                    {rows.length === 0 && (
                                        <div className="text-center text-muted py-10">No hay documentos eliminados.</div>
                                    )}
                                    {rows.filter((row) => row).map((row, index) => (
                                        <div key={row?.id || index} className="row align-items-center py-2 mx-0">
                                            <div className={this.props.selectable ? 'd-flex align-items-center col-md-5 col-5 px-0' : 'col-md-6 col-6 px-0'}>
                                                {this.props.selectable && (
                                                    <div className="checkbox-inline mr-5">
                                                        <label className="checkbox checkbox-outline mb-2">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedIds.includes(row?.id)}
                                                                onChange={() => this.toggleSelection(row.id)}
                                                            />
                                                            <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                        </label>
                                                    </div>
                                                )}
                                                <div className="symbol symbol-40 symbol-white mr-3">
                                                    <span className="symbol-label d-flex justify-content-start bg-white">
                                                        <i className="flaticon2-files-and-folders icon-lg text-primary"></i>
                                                    </span>
                                                </div>
                                                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                                                    <span className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{row.document_title || row.file_name || '-'}</span>
                                                    <span className="text-muted font-weight-bold font-size-lg">
                                                        {row.document_frequency === 'once' ? 'Unico' : row.document_frequency === 'yearly' ? 'Recurrente' : '-'}
                                                        {row.document_mimes && row.document_mimes.length > 0 ? ` | ${row.document_mimes.join(', ')}` : ''}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-4 px-0">
                                                <span className="text-muted font-weight-bold">{row.document_type_title || '-'}</span>
                                            </div>
                                            <div className="col-md-3 col-3 px-0">
                                                <span className="text-muted font-weight-bold">{row.expires_in_days ?? '-'} días</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}

                        {isLogView && (
                            <> 
                                <div className="row text-dark-75 font-weight-bolder mb-1 font-size-lg pb-3 mx-0">
                                    <div className="col-md-4 col-4 px-0">Nombre</div>
                                    <div className="col-md-3 col-3 px-0">Categoría</div>
                                    <div className="col-md-3 col-3 px-0">Acción</div>
                                    <div className="col-md-2 col-2 px-0">Usuario</div>
                                </div>
                                <div className="pt-3">
                                    {rows.length === 0 && (
                                        <div className="text-center text-muted py-10">No hay documentos eliminados.</div>
                                    )}
                                    {rows.filter((row) => row).map((row, index) => (
                                        <div key={row?.id || row?.recycle_log_id || index} className="row align-items-center py-2 mx-0">
                                            <div className="d-flex align-items-center col-md-4 col-4 px-0">
                                                <div className="symbol symbol-40 symbol-white mr-3">
                                                    <span className="symbol-label d-flex justify-content-start bg-white">
                                                        <i className="flaticon2-files-and-folders icon-lg text-primary"></i>
                                                    </span>
                                                </div>
                                                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                                                    <span className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{row.document_title || row.file_name || '-'}</span>
                                                    <span className="text-muted font-weight-bold font-size-lg">
                                                        {row.document_frequency === 'once' ? 'Unico' : row.document_frequency === 'yearly' ? 'Recurrente' : '-'}
                                                        {row.document_mimes && row.document_mimes.length > 0 ? ` | ${row.document_mimes.join(', ')}` : ''}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-3 px-0">
                                                <span className="text-muted font-weight-bold font-weight-bold">{row.document_type_title || '-'}</span>
                                            </div>
                                            <div className="col-md-3 col-3 px-0">
                                                <div>
                                                    <span
                                                        className={`${this.getStatusClasses(row.recycle_status || row.last_recycle_status)} text-nowrap`}
                                                        style={this.getStatusStyle(row.recycle_status || row.last_recycle_status)}
                                                    >
                                                        {row.recycle_status || row.last_recycle_status || '-'}
                                                    </span>
                                                </div>
                                                <div className="text-muted font-weight-bold font-size-sm mt-2">
                                                    {row.recycle_action_at || row.last_recycle_action_at || '-'}
                                                </div> 
                                            </div>
                                            <div className="col-md-2 col-2 px-0">
                                                <span className="text-muted font-weight-bold font-weight-bold">{row.recycle_user_name || row.last_recycle_user_name || '-'}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}

                        {total > perPage && (
                            <SimplePagination
                                key={`${this.props.logView ? 'log' : 'trash'}-${recycleStatus}-${createdAtStart || ''}-${createdAtEnd || ''}-${appliedSearch || ''}`}
                                updateCurrentPage={this.updateCurrentPage}
                                currentPage={currentPage}
                                totalFiles={total}
                                split={perPage}
                            />
                        )}
                    </>
                )}
            </>
        );

        if (this.props.modalId) {
            return (
                <div className="modal fade" id={this.props.modalId} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content bg-light-light">
                            <div className="modal-body px-15 py-10">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">{outerTitle}</h5>
                                {outerSubtitle && (
                                    <div className="text-muted">{outerSubtitle}</div>
                                )}
                                <div className="card card-custom gutter-b my-5">
                                    {filters}
                                    <div className="card-body pt-5">
                                        {tableContent}
                                    </div>
                                </div>
                                <div className="text-center">
                                    {this.props.footerActions}
                                    {isLogView && (
                                        <button type="button" className="btn btn-primary font-weight-bolder px-10 ml-4" onClick={this.closeModal}>Cerrar</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="card card-custom gutter-b">
                {filters}
                <div className="card-body pt-5">{tableContent}</div>
            </div>
        );
    }
}

export default RecycleBinTable;

if (document.getElementById('RecycleBinTable')) {
    ReactDOM.render(<RecycleBinTable />, document.getElementById('RecycleBinTable'));
}
